import { defineFetch } from 'resift';

const makeGetWidgetLayout = defineFetch({
  displayName: 'Update Widget Layout',
  make: (widgetLayoutId: string) => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/homepage-layouts/${widgetLayoutId}`,
      }),
  }),
});

export default makeGetWidgetLayout;
